import { Geo } from '../typings';
import { createRequestAtom } from '../utils/request-atom';

export const geoAtom = createRequestAtom<Geo>();
